export const dedupeBy = <T>(arr: T[], prop: keyof T): T[] =>
  arr.filter((item, i, self) => self.findIndex((t) => t[prop] === item[prop]) === i);

export const truncateMessageMiddle = (text: string, locationOfTruncate: number, lengthOfEnd = 5) => {
  if (text.length > locationOfTruncate + lengthOfEnd + 10) {
    return text.slice(0, locationOfTruncate) + "..." + text.slice(-lengthOfEnd, -1);
  }
  return text;
};
